import { ReactNode, UIEvent, useState } from 'react';
import { cn } from '@localagent/ui/lib/utils';
import { PageHeaderBar } from './PageHeaderBar';

type PageShellProps = {
  title?: ReactNode;
  description?: ReactNode;
  headerActions?: ReactNode;
  tabs?: ReactNode;
  headerSlot?: ReactNode;
  children: ReactNode;
};

export function PageShell({ title, description, headerActions, tabs, headerSlot, children }: PageShellProps) {
  const [scrolled, setScrolled] = useState(false);

  function handleScroll(event: UIEvent<HTMLDivElement>) {
    setScrolled(event.currentTarget.scrollTop > 0);
  }

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col">
      <div data-testid="page-shell-header" data-scrolled={scrolled ? 'true' : 'false'} className="z-10 shrink-0">
        <PageHeaderBar
          title={title}
          description={description}
          tabs={tabs}
          actions={headerActions}
          className={cn('transition-shadow', !headerSlot && scrolled && 'shadow-md')}
        />
        {headerSlot ? (
          <div className={cn('border-b bg-background px-4 py-3 transition-shadow', scrolled && 'shadow-md')}>
            {headerSlot}
          </div>
        ) : null}
      </div>

      <div
        data-testid="page-shell-scroll"
        onScroll={handleScroll}
        className="min-h-0 flex-1 overflow-y-auto p-6"
      >
        <div
          data-testid="page-shell-scrim"
          aria-hidden="true"
          className={cn(
            'pointer-events-none sticky top-0 -mb-3 h-3 bg-gradient-to-b from-background to-transparent transition-opacity',
            scrolled ? 'opacity-100' : 'opacity-0',
          )}
        />
        {children}
      </div>
    </div>
  );
}
